PPHybrid = App.loadClass "grower::classes/placement/PlantingPlanHybrid"


exports.Selections = (handler) ->
    self = this

    @setPlan = (fieldID, hybrids) ->
        plantingPlans = self.plantingPlans()
        hybridOrdering = self.hybridOrdering()

        plantingPlans(fieldID: fieldID).remove()

        for hybrid in hybrids
            if hybrid not instanceof PPHybrid
                debugLog 'Not a valid PlantingPlanHybrid object'
                debugLog hybrid
                continue
            plantingPlans.insert hybrid.get()

            hyb = hybrid.getHybrid()
            if hybridOrdering(hyb).count() is 0
                hybridOrdering.insert(hyb)

        self.plantingPlans(plantingPlans)
        self.hybridOrdering(hybridOrdering)

    # store the planting plan hybrid rows, basically as they were passed in
    @plantingPlans = ko.observable TAFFY()

    # store the hybrid objects here to maintain consistent ordering,
    # especially when adding and removing records
    @hybridOrdering = ko.observable TAFFY()


    @hybrids = ko.computed () ->
        results = []

        # Don't do anything with this value. It's just here so that knockout
        # will trigger hybrids() to be recomputed when plantingPlans() changes.
        # Since it's only used inside a loop, and the loop isn't executed when
        # plantingPlans() is first initialized, knockout won't pick up on that
        # dependency. This lets knockout know to add the dependency anyway.
        # It's kind of dumb, but I guess it works.
        self.plantingPlans()

        self.hybridOrdering()().each (hybrid) ->
            # Wow, I haven't had to do this since trying to inherit from the
            # Google Maps MVCArray class. We are creating a copy of the object
            # here, because if we pass the same object (by reference), knockout
            # won't update the view for it, even if the properties of the
            # object have changed. It will only add new or different objects.
            hybrid = $.extend({}, hybrid)

            conditions =
                hybridID: hybrid.id
                treatmentID: hybrid.treatmentID
            hybrid.units = self.plantingPlans()(conditions).sum('units')

            ###
                Prevent duplicates from appearing the sidebar
                https://www.pivotaltracker.com/story/show/150457617
            ###

            # initialize duplicate flag to false in case there are no results yet
            duplicate = false

            # see if there are any results that are a duplicate of the hybrid we're looking at
            for result in results when result.id is hybrid.id and result.treatmentID is hybrid.treatmentID
                # set the duplicate flag to true and exit the loop
                duplicate = true
                break

            # only add the hybrid if we don't have a duplicate and units are > 0
            if not duplicate and hybrid.units > 0
                results.push hybrid

        # Here come the HAX
        # We're directly inserting the html here because the knockout templates
        # were losing their bindings when a DAtaTable was applied, and creating
        # duplicates.  By emptying the DataTable each time we update the hybrids
        # and recreating the elements, we can ensure that they are unique.
        # This will be fixed ASAP by JW to not be such a hack
        tbody = $('#tbody-units')
        tbody.children().remove()
        for h in results
            htmlString = "<tr>
                            <td>" + h.displayName + "</td>
                            <td class='text-right'>" + h.units + "</td>
                        </tr>"
            tbody.append(htmlString)

        return results


    @totalUnits = ko.computed () ->
        return self.plantingPlans()().sum('units')

    @show_hr = ko.observable(handler.parent.has_multiple_steps)

    return this
